export default {

    indexOfferItemProtocolProcesses:        { method: 'get',    url: 'offer_item_protocol_processes' },
    storeOfferItemProtocolProcess:          { method: 'post',   url: 'offer_item_protocol_processes' },
    updateOfferItemProtocolProcess:         { method: 'put',    url: 'offer_item_protocol_processes/{id}'},
    destroyOfferItemProtocolProcess:        { method: 'delete', url: 'offer_item_protocol_processes/{id}'},
    indexOfferItemProtocolProcessStatus:    { method: 'get',    url: 'offer_item_protocol_processes/status' },

}